import React, { useEffect } from 'react';
import { useDrag } from 'react-dnd';
import { getEmptyImage } from 'react-dnd-html5-backend';
import { css } from '@emotion/react';
import styled from '@emotion/styled';

export const KNOB = 'KNOB';
export enum KNOB_ID {
  TOP_LEFT = 'top-left',
  TOP_RIGHT = 'top-right',
  BOTTOM_LEFT = 'bottom-left',
  BOTTOM_RIGHT = 'bottom-right',
}

interface DraggableKnobProps {
  top?: boolean;
  left?: boolean;
  right?: boolean;
  bottom?: boolean;
}

export function DraggableKnob({
  id,
  ...props
}: DraggableKnobProps & { id: string }) {
  const [, drag, preview] = useDrag({
    type: KNOB,
    item: { id },
  });

  useEffect(() => {
    preview(getEmptyImage());
  }, []);

  return <Knob ref={drag} {...props} />;
}

const Knob = styled.i<DraggableKnobProps>`
  position: absolute;
  width: 12px;
  height: 12px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 100%;
  background: #fff;
  cursor: grab;
  ${({ top }) => top &&
    css`
      top: 0;
      margin-top: -5px;
    `}
  ${({ left }) => left &&
    css`
      left: 0;
      margin-left: -5px;
    `}
  ${({ right }) => right &&
    css`
      right: 0;
      margin-right: -5px;
    `}
  ${({ bottom }) => bottom &&
    css`
      bottom: 0;
      margin-bottom: -5px;
    `}
`;
